<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Add Document Section</h4>
    <button type="button" class="icon" (click)="dismiss()"><span class="pi pi-times"></span></button>
  </div>
  <div class="form-row">
    <div class="col-md-12">

      <div class="form-group">

        <label for="document" class="btn btn-primary btn-round">Choose a training document</label>

        <input
          type="file"
          class="form-control"
          name="document"
          id="document"
          accept=".pdf"
          (change)="onFileChange($event)"
        />
        <ng-container *ngIf="selectedDocument">
          <p>Selected Document:</p>
          <ul>
            <li>{{ selectedDocument.name }}</li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" (click)="dismiss()" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
    <button type="button" [disabled]="!selectedDocument" (click)="submit()" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </div>
</div>
